// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ChooseAccountType_errorText__2gxf-","pendingMessage":"ChooseAccountType_pendingMessage__wwrOF","accountButtonsWrapper":"ChooseAccountType_accountButtonsWrapper__2Rvgd"};